import { render } from "./CompanyResearchCard.vue?vue&type=template&id=7940852e&scoped=true"
import script from "./CompanyResearchCard.vue?vue&type=script&lang=js"
export * from "./CompanyResearchCard.vue?vue&type=script&lang=js"

import "./CompanyResearchCard.vue?vue&type=style&index=0&id=7940852e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7940852e"]])

export default __exports__